import { createProvider, setGlobal, addReducer } from "reactn";
import { getUserLanguage, DEFAULT_LANG } from "lib/locale-helpers";
import { SUPABASE_STORAGE_KEY } from "@ugitgud/legos/util/auth/general";

// Reducers
const initReducers = (Provider) => {
  const actions = [UPDATE_STATIC_JSON];

  actions.forEach((action) => {
    if (Provider) {
      Provider.addReducer(action.type, action.actionFn);
    } else {
      addReducer(action.type, action.actionFn);
    }
  });
};

const UPDATE_STATIC_JSON = {
  type: "UPDATE_STATIC_JSON",
  actionFn: (global, dispatch, url, value) => ({
    [url]: value,
  }),
};

// Used on both server and client
// Return Provider component to wrap app
export const reactnInit = (props = {}) => {
  const { req, initState = {} } = props;
  const Provider = createProvider({
    clientChampionFavorites: undefined,
    clientSummonerFavorites: undefined,
    language: getUserLanguage({ req }) || DEFAULT_LANG,
    settingsNotification: false,
    verificationBar: false,
    allowCssTransition: false,
    ...initState,
  });

  initReducers(Provider);

  return Provider;
};

// Initialized only on client side
export const setClientReactNState = (Provider) => {
  const curLang = Provider.getGlobal().language;

  Provider.setGlobal({
    authToken: null,
    loggingIn: localStorage.getItem(SUPABASE_STORAGE_KEY) !== null,
    clientRegion: localStorage.getItem("summonerRegion") || "na1",
    language: getUserLanguage({ language: curLang }) || DEFAULT_LANG, // Global var language is used to handle
  });
};

const globalReactN = reactnInit();
export default globalReactN;
